<template>
  <div class="auth" :style="backgroundStyles">
    <span v-if="headerText"
          :style="{color: appearance.color}"
          class="auth__header"
          v-html="headerText"
    />

    <div class="auth__body">
      <RouterView v-slot="{ Component }">
        <component :is="Component" />
      </RouterView>
    </div>

    <span v-if="footerText"
          class="auth__footer"
          :style="{color: appearance.color}"
          v-html="footerText"
    />
  </div>
</template>
<script setup>
import {computed, onMounted} from "vue";
import {useI18n} from "vue-i18n";
import {useRoute} from "vue-router";
import {useLoader} from "@/js/Plugins/Loader.js";

const { t } = useI18n();
const route = useRoute();
const loader = useLoader();

const appearance = computed(() => {
  return window.setup.login;
})
const backgroundStyles = computed(() => {
  const image = appearance.value.background_image;
  const backgroundColor = appearance.value.background;

  return {
    backgroundImage: image ? `url(${image})` : null,
    backgroundColor
  }
});
const headerText = computed(() => {
  switch (route.name)
  {
    case 'auth.login':
      return appearance.value.welcome_text;
    case 'auth.password-reminder':
      return null;
    case 'auth.registration':
      return t('front.registration');
  }
});
const footerText = computed(() => {
  if (route.name === 'auth.login') return  appearance.value.bottom_text;
  return null;
});

onMounted(() => {
  loader.hide();
})
</script>
<style lang="scss" scoped>
@import "@/css/functions";
@import "@/css/variables";
@import "bootstrap/scss/functions";
@import "bootstrap/scss/mixins";
@import "bootstrap/scss/variables";

.auth {
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  background-attachment: fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  gap: spacing(3);
  padding: spacing(2);

  @include media-breakpoint-up(sm) {
    justify-content: center;
  }

  &__header {
    font-size: fontSize(1);
    font-weight: $font-weight-medium;
  }

  &__body {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
}
</style>